// Game-wide constants and content metadata. No secrets here.
import type { Canon, Category, Difficulty, DifficultyFilter } from "./types";

export const GAME = {
  /** First to N correct answers wins (the racer's track has N positions). */
  defaultFinishLine: 7,
  /** Private rooms default longer — the coordination to gather is worth a meatier race. */
  roomDefaultFinishLine: 10,
  minFinishLine: 3,
  maxFinishLine: 25,
  /** Submissions faster than this are rejected as impossible (anti-cheat, ms). */
  minAnswerMs: 250,
  /** A question left unanswered longer than this counts as timed out (ms). */
  maxAnswerMs: 60_000,
  /** Default wrong-answer behavior: no time penalty, racer simply doesn't advance. */
  wrongAnswerPenaltyMs: 0,
  /** Client poll cadence for multiplayer opponent positions (ms). */
  pollIntervalMs: 750,
} as const;

export const CANON_RANK: Record<Canon, number> = {
  "protestant-66": 0,
  "catholic-73": 1,
  orthodox: 2,
};

export const DEFAULT_CANON: Canon = "protestant-66";
export const DEFAULT_TRANSLATION = "WEB";

export const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  easy: "Sunday School",
  medium: "Disciple",
  hard: "Scholar",
};

export const DIFFICULTY_ORDER: Difficulty[] = ["easy", "medium", "hard"];

export const DIFFICULTY_FILTER_LABELS: Record<DifficultyFilter, string> = {
  mixed: "Mixed",
  easy: "Sunday School",
  medium: "Disciple",
  hard: "Scholar",
};

export const CATEGORY_LABELS: Record<Category, string> = {
  "bible-trivia": "Bible Trivia",
  "name-that-person": "Name That Person",
  "who-said-it": "Who Said It?",
  "finish-the-verse": "Finish the Verse",
  "books-of-the-bible": "Books of the Bible",
  "places-geography": "Places & Geography",
  "parables-miracles": "Parables & Miracles",
  chronology: "Chronology",
  "people-relationships": "People & Relationships",
};

export const ALL_CATEGORIES = Object.keys(CATEGORY_LABELS) as Category[];
